import { createTheme } from '@mui/material/styles';

// Default blue theme (original)
export const blueTheme = createTheme({
  palette: {
    primary: {
      main: '#1E4D8C', // Глубокий синий
      light: '#3B7DCC',
      dark: '#0D2C5B',
      contrastText: '#fff',
    },
    secondary: {
      main: '#FF6B6B', // Яркий коралловый
      light: '#FF9E9E',
      dark: '#D14545',
      contrastText: '#fff',
    },
    success: {
      main: '#2ECC71', // Яркий зеленый
      light: '#7ED6A9',
      dark: '#25A25A'
    },
    warning: {
      main: '#F39C12', // Насыщенный оранжевый
      light: '#F8C471',
      dark: '#D68910'
    },
    error: {
      main: '#E74C3C', // Яркий красный
      light: '#F1948A',
      dark: '#B03A2E'
    },
    info: {
      main: '#3498DB', // Яркий голубой
      light: '#85C1E9',
      dark: '#2874A6'
    },
    background: {
      default: '#F8FAFC',
      paper: '#FFFFFF',
    },
    text: {
      primary: '#2C3E50',
      secondary: '#5D6D7E',
    },
    divider: 'rgba(0, 0, 0, 0.08)',
  },
  typography: {
    fontFamily: '"Montserrat", "Roboto", "Arial", sans-serif',
    h1: {
      fontWeight: 700,
      fontSize: '2.5rem',
    },
    h2: {
      fontWeight: 600,
      fontSize: '2rem',
    },
    h3: {
      fontWeight: 600,
      fontSize: '1.75rem',
    },
    h4: {
      fontWeight: 600,
      fontSize: '1.5rem',
    },
    h5: {
      fontWeight: 500,
      fontSize: '1.25rem',
    },
    h6: {
      fontWeight: 500,
      fontSize: '1rem',
    },
    button: {
      fontWeight: 500,
      textTransform: 'none',
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
          borderRadius: '8px',
          transition: 'all 0.3s ease',
          '&:hover': {
            boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.15)',
            transform: 'translateY(-2px)',
          },
        },
        contained: {
          padding: '10px 24px',
          fontWeight: 600,
        },
        outlined: {
          borderWidth: '2px',
          '&:hover': {
            borderWidth: '2px',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.05)',
          transition: 'transform 0.3s ease, box-shadow 0.3s ease',
          '&:hover': {
            boxShadow: '0px 8px 30px rgba(0, 0, 0, 0.1)',
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        elevation1: {
          boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.05)',
        },
      },
    },
  },
});

// Green theme
export const greenTheme = createTheme({
  palette: {
    primary: {
      main: '#2E7D32', // Зеленый
      light: '#4CAF50',
      dark: '#1B5E20',
      contrastText: '#fff',
    },
    secondary: {
      main: '#FF9800', // Оранжевый
      light: '#FFB74D',
      dark: '#F57C00',
      contrastText: '#fff',
    },
    success: {
      main: '#2ECC71',
      light: '#7ED6A9',
      dark: '#25A25A'
    },
    warning: {
      main: '#F39C12',
      light: '#F8C471',
      dark: '#D68910'
    },
    error: {
      main: '#E74C3C',
      light: '#F1948A',
      dark: '#B03A2E'
    },
    info: {
      main: '#3498DB',
      light: '#85C1E9',
      dark: '#2874A6'
    },
    background: {
      default: '#F5F9F5',
      paper: '#FFFFFF',
    },
    text: {
      primary: '#2C3E50',
      secondary: '#5D6D7E',
    },
    divider: 'rgba(0, 0, 0, 0.08)',
  },
  typography: {
    fontFamily: '"Montserrat", "Roboto", "Arial", sans-serif',
    h1: {
      fontWeight: 700,
      fontSize: '2.5rem',
    },
    h2: {
      fontWeight: 600,
      fontSize: '2rem',
    },
    h3: {
      fontWeight: 600,
      fontSize: '1.75rem',
    },
    h4: {
      fontWeight: 600,
      fontSize: '1.5rem',
    },
    h5: {
      fontWeight: 500,
      fontSize: '1.25rem',
    },
    h6: {
      fontWeight: 500,
      fontSize: '1rem',
    },
    button: {
      fontWeight: 500,
      textTransform: 'none',
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
          borderRadius: '8px',
          transition: 'all 0.3s ease',
          '&:hover': {
            boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.15)',
            transform: 'translateY(-2px)',
          },
        },
        contained: {
          padding: '10px 24px',
          fontWeight: 600,
        },
        outlined: {
          borderWidth: '2px',
          '&:hover': {
            borderWidth: '2px',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.05)',
          transition: 'transform 0.3s ease, box-shadow 0.3s ease',
          '&:hover': {
            boxShadow: '0px 8px 30px rgba(0, 0, 0, 0.1)',
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        elevation1: {
          boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.05)',
        },
      },
    },
  },
});

// Dark theme
export const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#90CAF9', // Светло-синий
      light: '#BBDEFB',
      dark: '#42A5F5',
      contrastText: '#121212',
    },
    secondary: {
      main: '#F48FB1', // Розовый
      light: '#F8BBD0',
      dark: '#EC407A',
      contrastText: '#121212',
    },
    success: {
      main: '#81C784',
      light: '#A5D6A7',
      dark: '#66BB6A'
    },
    warning: {
      main: '#FFB74D',
      light: '#FFCC80',
      dark: '#FFA726'
    },
    error: {
      main: '#E57373',
      light: '#EF9A9A',
      dark: '#EF5350'
    },
    info: {
      main: '#64B5F6',
      light: '#90CAF9',
      dark: '#42A5F5'
    },
    background: {
      default: '#121212',
      paper: '#1E1E1E',
    },
    text: {
      primary: '#FFFFFF',
      secondary: '#B0BEC5',
    },
    divider: 'rgba(255, 255, 255, 0.12)',
  },
  typography: {
    fontFamily: '"Montserrat", "Roboto", "Arial", sans-serif',
    h1: {
      fontWeight: 700,
      fontSize: '2.5rem',
    },
    h2: {
      fontWeight: 600,
      fontSize: '2rem',
    },
    h3: {
      fontWeight: 600,
      fontSize: '1.75rem',
    },
    h4: {
      fontWeight: 600,
      fontSize: '1.5rem',
    },
    h5: {
      fontWeight: 500,
      fontSize: '1.25rem',
    },
    h6: {
      fontWeight: 500,
      fontSize: '1rem',
    },
    button: {
      fontWeight: 500,
      textTransform: 'none',
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
          borderRadius: '8px',
          transition: 'all 0.3s ease',
          '&:hover': {
            boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.3)',
            transform: 'translateY(-2px)',
          },
        },
        contained: {
          padding: '10px 24px',
          fontWeight: 600,
        },
        outlined: {
          borderWidth: '2px',
          '&:hover': {
            borderWidth: '2px',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.2)',
          transition: 'transform 0.3s ease, box-shadow 0.3s ease',
          '&:hover': {
            boxShadow: '0px 8px 30px rgba(0, 0, 0, 0.3)',
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        elevation1: {
          boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.2)',
        },
      },
    },
  },
});

// Map theme names to theme objects
export const themeMap = {
  blue: blueTheme,
  green: greenTheme,
  dark: darkTheme
};

// Default theme
export default blueTheme;
